import { render, staticRenderFns } from "./RedMarks.vue?vue&type=template&id=67f61ab3&scoped=true&"
import script from "./RedMarks.vue?vue&type=script&lang=js&"
export * from "./RedMarks.vue?vue&type=script&lang=js&"
import style0 from "./RedMarks.vue?vue&type=style&index=0&id=67f61ab3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f61ab3",
  null
  
)

export default component.exports